<markant-callout
  *ngFor="let message of messages"
  color-scheme="info"
  theme="colored"
>
  <div slot="content">
    <div class="callout-content-wrapper">
      <markant-icon icon="m_info"></markant-icon>
      {{ message }}
    </div>
  </div>
</markant-callout>
